"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParkingEndError = exports.ParkingStartError = void 0;
/**
 * Defines the failure conditions that can occur when starting a parking event.
 * The Frontend e.g. show appropriate error messages based on this information.
 */
var ParkingStartError;
(function (ParkingStartError) {
    ParkingStartError["AlreadyParking"] = "alreadyParking";
    ParkingStartError["AreaFull"] = "areaFull";
    ParkingStartError["Banned"] = "banned";
    ParkingStartError["Cooldown"] = "cooldown";
    ParkingStartError["VehicleBanned"] = "VehicleBanned";
    ParkingStartError["NoVehicleAtGate"] = "noVehicleAtGate";
    ParkingStartError["WaitForPreviousVehicle"] = "WaitForPreviousVehicle";
    ParkingStartError["NoReplyFromGate"] = "NoReplyFromGate";
})(ParkingStartError = exports.ParkingStartError || (exports.ParkingStartError = {}));
/**
 * Defines the failure conditions that can occur when ending a parking event.
 * The Frontend e.g. show appropriate error messages based on this information.
 */
var ParkingEndError;
(function (ParkingEndError) {
    ParkingEndError["NotParking"] = "notParking";
    ParkingEndError["NoVehicleAtGate"] = "noVehicleAtGate";
    ParkingEndError["WaitForPreviousVehicle"] = "WaitForPreviousVehicle";
    ParkingEndError["NoReplyFromGate"] = "NoReplyFromGate";
})(ParkingEndError = exports.ParkingEndError || (exports.ParkingEndError = {}));
//# sourceMappingURL=parkingEvent.js.map